import { render, staticRenderFns } from "./vw_student_overall_count_region.vue?vue&type=template&id=9385375e&scoped=true&"
import script from "./vw_student_overall_count_region.vue?vue&type=script&lang=js&"
export * from "./vw_student_overall_count_region.vue?vue&type=script&lang=js&"
import style0 from "./vw_student_overall_count_region.vue?vue&type=style&index=0&id=9385375e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9385375e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
